import { ColoresTema, TEMAS } from './tema.constants';

export interface ColorPaleta {
  nombre: string;
  codigo: string;
  variantes: ColoresTema;
}

export const COLOR_POR_DEFECTO = '#1E3A8A';

const VARIANTES_AMBAR: ColoresTema = {
  primary: '#FFC107',
  primaryHover: '#ECAE06',
  primaryActive: '#CCA006',
  primaryDark: '#BF9105',
  primaryDarkHover: '#D4A20E',
  primaryDarkActive: '#A67E04',
  primaryLight: '#FFD06B',
  primaryLightHover: '#FFD98A',
  primaryLightActive: '#FFC94D'
};

const VARIANTES_BURDEOS: ColoresTema = {
  primary: '#8B0000',
  primaryHover: '#A00000',
  primaryActive: '#720000',
  primaryDark: '#5A0000',
  primaryDarkHover: '#700000',
  primaryDarkActive: '#450000',
  primaryLight: '#B53333',
  primaryLightHover: '#C44D4D',
  primaryLightActive: '#A31A1A'
};

const VARIANTES_VERDE: ColoresTema = {
  primary: '#2F855A',
  primaryHover: '#38A169',
  primaryActive: '#276749',
  primaryDark: '#1E5C3A',
  primaryDarkHover: '#276749',
  primaryDarkActive: '#164D30',
  primaryLight: '#68A87E',
  primaryLightHover: '#7FBA94',
  primaryLightActive: '#559468'
};

export const PALETA_COLORES: ColorPaleta[] = [
  { nombre: 'Azul',    codigo: '#1E3A8A', variantes: TEMAS.deudor },
  { nombre: 'Morado',  codigo: '#660066', variantes: TEMAS.emisor },
  { nombre: 'Ámbar',   codigo: '#FFC107', variantes: VARIANTES_AMBAR },
  { nombre: 'Verde',   codigo: '#2F855A', variantes: VARIANTES_VERDE },
  { nombre: 'Burdeos', codigo: '#8B0000', variantes: VARIANTES_BURDEOS },
];

export const CODIGOS_PALETA_PERMITIDOS: string[] = PALETA_COLORES.map(c => c.codigo);
